import React, { createContext, useContext, useState } from 'react';

import { useColumnsPresetStorage } from '../../../../components/TableGrid/hooks/useColumnsPresetStorage';

type ColumnPresetContextProps = {
  presetColumns: string[];
  onPresetColumnsChange: (ids: string[]) => void;
};

const ColumnPresetContext = createContext<ColumnPresetContextProps | undefined>(undefined);

type SearchProviderProps = { children: React.ReactNode };

export const ColumnPresetContextProvider = ({ children }: SearchProviderProps) => {
  const { storedPresetColumns, storePresetColumns } = useColumnsPresetStorage({
    columnsPresetStorageId: 'financial-data',
  });
  const [presetColumns, setPresetColumns] = useState<string[]>(storedPresetColumns);

  const onPresetColumnsChange = (ids: string[]) => {
    storePresetColumns(ids);
    setPresetColumns(ids);
  };

  return (
    <ColumnPresetContext.Provider value={{ presetColumns, onPresetColumnsChange }}>
      {children}
    </ColumnPresetContext.Provider>
  );
};

export const useColumnPresetState = () => {
  const context = useContext(ColumnPresetContext);

  if (context === undefined) {
    throw new Error('ColumnPresetContext must be used within a ColumnPresetContextProvider');
  }

  return context;
};
